import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getSpecialists = async (salonId: string | undefined) => {

  const { data, error } = await supabase
    .from('teams')
    .select(`
      id,
      full_name,
      avatar,
      salon
    `)
    .eq('salon', salonId)

  if (error) {
    throw new Error(error.message);
  }

  return data;
}

export default function useGetSpecialistsBySalonId(salonId: string | undefined) {
  return useQuery({
    queryKey: ['salonSpecialists', salonId],
    queryFn: () => getSpecialists(salonId),
    staleTime: 0,
    enabled: !!salonId
  })
} 